/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelInvitedCarrier.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/invited-carrier";

export class AutogenModelInvitedCarrier<RowType extends ModelRow> extends Endpoint<RowType, RowInvitedCarrierFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowInvitedCarrier extends ModelRow<RowInvitedCarrierFields> {
	constructor(values?: Partial<RowInvitedCarrierFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowInvitedCarrierFields {
	company_id: string;
	dot_number: string;
	entered_by_user_id: string;
	icc_number: string;
	id: string;
	invited_date: Date;
	name: string;
}

